import React from 'react';

const Mic = () => {
    return (
      <div className="fourDots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    );
  };

export default Mic;